var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { Card } from "@irati/ui/src/Layout";
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo";
import CreateCSV from "./CreateCSV";
import { SectionTitle } from "../Analysis";
import { ReactTable } from "../../ui/Table";
import columns from "./table/columns";
import FlexWrapper from "../../ui/Layout/FlexWrapper";
import NoData from "./table/NoData";
import { LoadingOverlay } from "../../ui/LoadingOverlay";
import AnalysisCommentsConsumer from "./AnalysisCommentsConsumer";
import { ResetButton } from "./styled";
var PAGE_SIZE = 20;
var CommentsTable = function (props) {
    var idNamespace = id("Table", props);
    var formatMessage = props.formatMessage;
    return (React.createElement(AnalysisCommentsConsumer, null, function (data) {
        var loading = data.loading, bookmark = data.bookmark, sentiment = data.sentiment, comments = data.comments, page = data.page, onPageChange = data.onPageChange, updateFilter = data.updateFilter, total = data.total, schedule = data.schedule, tenantId = data.tenantId;
        var driverCount = get(schedule, "drivers.results.length") || 0;
        var showTable = loading || total > 0 || bookmark || sentiment;
        var userTenantId = authentication.userTenant().uuid;
        var showExportButton = total > 0 && userTenantId === tenantId;
        return (React.createElement("div", { id: idNamespace },
            React.createElement(FlexWrapper, { justify: "space-between" },
                React.createElement(SectionTitle, { title: formatMessage({ id: "insights.analysis.comments.title" }), badgeCopy: formatMessage({ id: "insights.analysis.comments.summary" }, { total: total }) }),
                React.createElement(FlexWrapper, { justify: "space-between" },
                    React.createElement(HasPermissionTo, { permissions: ["insights.bookmarkComments"], Error: null },
                        React.createElement(ResetButton, { disabled: !sentiment && !bookmark, onClick: updateFilter, small: true },
                            React.createElement(FormattedMessage, { id: "insights.analysis.comments.resetAllButton" }))),
                    showExportButton && (React.createElement(HasPermissionTo, { permissions: ["insights.schedulesReporting"], Error: null },
                        React.createElement(CreateCSV, { tenantUuid: tenantId, cycleId: schedule.id, count: total }))))),
            React.createElement(LoadingOverlay, { loading: loading },
                React.createElement(Card, { small: true },
                    showTable && (React.createElement(ReactTable, { id: id("CommentsTable", idNamespace), data: comments, loading: loading && total === 0, pages: Math.ceil(total / PAGE_SIZE), page: page, columns: columns(formatMessage, idNamespace, driverCount), showPagination: total > PAGE_SIZE, defaultPageSize: PAGE_SIZE, NoDataComponent: NoData, onPageChange: onPageChange, getPaginationProps: function (allProps) { return (__assign(__assign({}, allProps), { shouldScrollOnUpdate: false })); } })),
                    !showTable && React.createElement(FormattedMessage, { id: "insights.analysis.comments.empty" })))));
    }));
};
CommentsTable.propTypes = {
    formatMessage: PropTypes.func.isRequired
};
export default injectIntl(CommentsTable);
